import type { ReactNode, SVGProps } from "react";

/**
 * Значки для кнопок. Рисуются цветом текста кнопки (currentColor) и скрыты от экранных читалок:
 * название кнопки определяется только её подписью.
 */
function Icon({ children, ...props }: SVGProps<SVGSVGElement> & { children: ReactNode }) {
  return (
    <svg
      className="btn__icon"
      viewBox="0 0 24 24"
      width="1.3em"
      height="1.3em"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      {children}
    </svg>
  );
}

/** «Поделиться»: стрелка вверх из коробки. */
export function ShareIcon() {
  return (
    <Icon>
      <path d="M12 3v12" />
      <path d="M8 7l4-4 4 4" />
      <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7" />
    </Icon>
  );
}

/** Двое: для действий вместе с партнёром. */
export function PairIcon() {
  return (
    <Icon>
      <circle cx="9" cy="8" r="3.2" />
      <path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" />
      <circle cx="17" cy="9" r="2.6" />
      <path d="M16.2 14.2c2.9.3 4.8 2.6 4.8 5.8" />
    </Icon>
  );
}

/** Один человек: для действий в одиночку. */
export function SoloIcon() {
  return (
    <Icon>
      <circle cx="12" cy="8" r="3.6" />
      <path d="M5 20c0-3.9 3.1-7 7-7s7 3.1 7 7" />
    </Icon>
  );
}

/** «Назад». */
export function BackIcon() {
  return (
    <Icon>
      <path d="M15 5l-7 7 7 7" />
    </Icon>
  );
}
